export default __webpack_public_path__ + "static/media/ARPL.91c9d04f.png";